import { z } from 'zod';
import { isMongoId } from '../../helpers';
import { BaseRevaluationSchema, CreateRevaluationSchema } from '../revaluation';
import { TransactionOperation } from 'further-types/lp/transaction';
import { currencyRateOverridesSchema } from '../unrealised-fx-gain-or-loss';
import CalendarDay from '../../../utils/calendar-day';

const PeriodEndCreateRevaluationSchema = CreateRevaluationSchema.extend({
  revaluations: z.array(
    BaseRevaluationSchema.extend({
      ledgerDate: z.instanceof(CalendarDay),
    }),
  ),
});

export const CreateRevaluationsForPeriodEndInput = z.object({
  periodId: z.string().refine(isMongoId(), {
    message: 'Please provide a valid period ID',
  }),
  items: z.array(PeriodEndCreateRevaluationSchema),
});

export type CreateRevaluationsForPeriodEndType = z.infer<
  typeof CreateRevaluationsForPeriodEndInput
>;

export const CreateUnrealisedGainsForPeriodEndInput = z.object({
  periodId: z.string().refine(isMongoId(), {
    message: 'Please provide a valid period ID',
  }),
  fxGains: z
    .object({
      transactions: z.array(
        z.object({
          sourceTransactionId: z.string().refine(isMongoId(), {
            message: 'Please provide a valid source transaction ID',
          }),
          transactions: z.array(
            z.object({
              transactionTypeId: z.string().refine(isMongoId(), {
                message: 'Please provide a valid transaction type ID',
              }),
              operationType: z.nativeEnum(TransactionOperation),
            }),
          ),
        }),
      ),
      currencyRateOverrides: currencyRateOverridesSchema.optional(),
    })
    .optional(),
  cashFxGains: z
    .object({
      bankAccounts: z.array(
        z.object({
          bankAccountId: z.string().refine(isMongoId(), {
            message: 'Please provide a valid bank account ID',
          }),
          transactions: z.array(
            z.object({
              transactionTypeId: z.string().refine(isMongoId(), {
                message: 'Please provide a valid transaction type ID',
              }),
              operationType: z.nativeEnum(TransactionOperation),
            }),
          ),
        }),
      ),
      currencyRateOverrides: currencyRateOverridesSchema.optional(),
    })
    .optional(),
});

export type CreateUnrealisedGainsForPeriodEndType = z.infer<
  typeof CreateUnrealisedGainsForPeriodEndInput
>;
